import { create } from "zustand";
import { patchOnboardingStateOnServer } from "../utils/net/onboardingApi";

interface SoundStore {
  soundsEnabled: boolean;
  setSoundsEnabled: (enabled: boolean) => void;
  /** True while an Elder-music dialog (election or onboarding) is mounted.
   *  When true, MapCanvas pauses the ocean ambient so it doesn't play under the dialog music. */
  oceanDucked: boolean;
  setOceanDucked: (ducked: boolean) => void;
}

/**
 * Source of truth for `soundsEnabled` is the DB field `sounds_enabled` on
 * `user_onboarding_kv`. `App.tsx` hydrates this store from the `onboarding-state`
 * query cache right after the server gate passes. Before hydration we default
 * to `true` so sounds work from the first frame.
 */
const useSoundStore = create<SoundStore>((set) => ({
  soundsEnabled: true,
  setSoundsEnabled: (enabled: boolean) => {
    patchOnboardingStateOnServer({ sounds_enabled: enabled }).catch(() => {});
    set({ soundsEnabled: enabled });
  },
  oceanDucked: false,
  setOceanDucked: (ducked: boolean) => set({ oceanDucked: ducked }),
}));

export default useSoundStore;
